import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

import { Container } from "reactstrap";
import TitleDocPlace from "../../components/title/title";
import SearchDocPlace from "../../components/search/search";
import Button from "@mui/material/Button";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import LoadingComponent from "../../components/loading";

import { getRolList, deleteRolList } from "../../store/rol/actions";
import NewItemDocPlace from "./components/new/new";
import JustifyBetween from "../../components/common/JustifyBetween";
import { BaseDataTable } from "../../components/common/BaseDataTable";
import CellActions from "../../components/common/CellActions";
import { colors } from "../../components/theme";

const DocumentTypeDocPlace = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [startPage] = useState(true);
  const [dataRols, setDataRols] = useState([]);
  const [showNew, setShowNew] = React.useState(false);
  const [docTypesAPI, setDocTypesAPI] = useState([]);
  const [page] = useState(1);
  const [pageSize] = useState(100);
  const [defaultData, setDefaultData] = React.useState("");

  const { responseRol, loadingRol } = useSelector((state) => ({
    responseRol: state.Rol.responseRol,
    loadingRol: state.Rol.loadingRol,
  }));
  const { responseRolDelete, loadingRolDelete } = useSelector((state) => ({
    responseRolDelete: state.Rol.responseRolDelete,
    loadingRolDelete: state.Rol.loadingRolDelete,
  }));

  useEffect(() => {
    dispatch(getRolList({ page: page, pageSize: pageSize }, navigate));
  }, [startPage, page, pageSize]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (responseRol && responseRol.data) {
      setDataRols(responseRol.data);
      setDocTypesAPI(responseRol.data);
    }
  }, [responseRol]);

  useEffect(() => {
    if (responseRolDelete !== null) {
      dispatch(getRolList({ page: page, pageSize: pageSize }, navigate));
    }
  }, [responseRolDelete]); // eslint-disable-line react-hooks/exhaustive-deps

  const findDocumentTypes = (term) => {
    setDataRols(
      term
        ? docTypesAPI.filter((doc) => doc.name.toLowerCase().includes(term))
        : docTypesAPI
    );
  };

  const optionGrid = (value) => {
    if (value.action === "edit") {
      setDefaultData(value.row.row);
      setShowNew(true);
    } else {
      deleteItem(value.id);
    }
  };

  const deleteItem = (id) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: "Are you sure?",
      text: "",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
    }).then((willDelete) => {
      if (willDelete.value) {
        dispatch(deleteRolList(id, navigate));
      }
    });
  };

  const searchFile = (filterSearch) => {
    findDocumentTypes(filterSearch);
  };

  const refresh = () => {
    setDefaultData(null);
    dispatch(getRolList({ page: page, pageSize: pageSize }, navigate));
  };

  const closeModal = () => {
    setDefaultData(null);
    setShowNew(false);
  };

  const selectOption = (op, id, row) => {
    console.log(op, id, row);
    optionSelect({ action: op, id: id, row: row });
  };

  const optionSelect = (event) => {
    console.log(event);
    optionGrid(event);
  };

  const columns = [
    {
      field: "name",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Name",
    },
    {
      field: "description",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Description",
    },
    {
      field: "read",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Read Permission",
      valueGetter: (params) =>
        `${params.row.read === 0 ? "Not Active" : "Active"}`,
    },
    {
      field: "write",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Write Permission",
      valueGetter: (params) =>
        `${params.row.write === 0 ? "Not Active" : "Active"}`,
    },
    {
      field: "delete",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Delete Permission",
      valueGetter: (params) =>
        `${params.row.delete === 0 ? "Not Active" : "Active"}`,
    },
    {
      field: "options",
      headerName: "",
      sortable: false,
      headerClassName: "MuiTableHead-root",
      flex: 0.1,
      renderCell: (params) => (
        <CellActions
          id={params.id}
          row={params.row}
          onEdit={() => selectOption("edit", params.id, params)}
          onRemove={() => selectOption("remove", params.id, params)}
        />
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>DocPlace Roles</title>
        </MetaTags>
        <Container fluid>
          <TitleDocPlace title={"Roles"} viewActive={false} />
          <ToastContainer autoClose={3000} />
          <LoadingComponent
            show={loadingRol || loadingRolDelete}
            text={loadingRol ? "Getting Roles..." : "Deleting Rol"}
          />
          <JustifyBetween style={{ marginBottom: 20 }}>
            <Button
              onClick={() => {
                setDefaultData("");
                setShowNew(true);
              }}
              size="small"
              color="primary"
              style={{ backgroundColor: colors.blue }}
              variant="contained"
            >
              Create Role
            </Button>
            <SearchDocPlace callSearch={searchFile.bind(this)} />
          </JustifyBetween>

          <BaseDataTable
            data={dataRols || []}
            columns={columns}
            option={optionGrid.bind(this)}
          />
        </Container>
      </div>
      <NewItemDocPlace
        done={refresh.bind(0, this)}
        close={closeModal.bind(this)}
        default={defaultData}
        show={showNew}
      />
    </React.Fragment>
  );
};

export default DocumentTypeDocPlace;
